// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3rLJH","header":"ReportDetails_header__39u2R","title":"ReportDetails_title__34dz7","left":"ReportDetails_left__3Br19"};